// eslint-disable-next-line
import React, { useEffect, useState, useRef, useContext, Fragment } from 'react'
import { getArtistById, getAlbumsByArtistId, getSonglistURL, getAllSongsByArtist } from '../../utils/api'
import { Link, useHistory } from 'react-router-dom'
import { MusicPlayerContext } from '../../context/MusicPlayerContext'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { useAuth } from '../../hooks/useAuth'
import { getTime } from '../../utils/convert-time'
import { httpToHttps, formatDate } from '../../utils/helper-functions'
import { useTranslation } from 'react-i18next'
import { Loading } from '../helpers/Loading'
import { Pagination } from '../helpers/Pagination'
import { AccordianComp } from '../helpers/ChakraAccordian'
import { SectionHeader } from '../helpers/SectionHeader'
import { ButtonIcons } from '../helpers/ButtonIcons'
import { Box, useColorModeValue } from '@chakra-ui/react'
import { AllAlbums } from './AllAlbums'
import { usePaginatedQuery, useQueryCache } from 'react-query'
// import { ChevronDownIcon } from '@chakra-ui/icons'
import { RiHeartLine, RiPauseLine, RiPlayLine } from 'react-icons/ri'
import { SimilarArtists } from './SimilarArtists'
import { BackgroundBanner } from '../helpers/BackgroundBanner'

const PAGE_SIZE = 30
export const ByArtist = ( { match } ) => {
  const { params: { id } } = match
  const [artist, setArtist] = useState( {} )
  const [simiArtists] = useAuth( id )
  const [topSongs, setTopSongs] = useState( [] )
  const [topAlbums, setTopAlbums] = useState( [] )
  const [loading, setLoading] = useState( false )
  const [currentPage, setCurrentPage] = useState( 1 )
  const [totalResults, setTotalResults] = useState( 0 )
  const [resultsPerPage] = useState( 5 )
  const [toggle, setToggle] = useState( true )
  const { i18n } = useTranslation( ['album', 'chartlist'], { useSuspense: false } )
  const [state, setState] = useContext( MusicPlayerContext )
  const { currentTrackName, playTrack, isPlaying } = useMusicPlayer()
  const [showMore, setShowMore] = useState( false )
  const onToggle = () => setToggle( !toggle )
  const [currentAlbums, setCurrentAlbums] = useState( 1 )
  // const scrollRef = useRef( null )
  let tracksArr = []
  const [page, setPage] = useState( 1 )


  // eslint-disable-next-line
  const history = useHistory()
  const countRef = useRef( null )
  const [count, setCount] = useState( 0 )

  /***Artist Details start here***/
  useEffect( () => {
    let ids
    const artistDetails = async () => {
      setShowMore( false )
      setLoading( true )
      const result = await getArtistById( id )
      console.log( result?.artist?.name, "artist 1st render" )
      setArtist( result )
      setTopSongs( result.hotSongs )
      let songIds = result.hotSongs.map( song => song.id )
      ids = songIds
      const urls = await getSonglistURL( ids )
      let songsArr = result.hotSongs.map( ( song, i ) => {
        urls.map( url => {
          if ( song.id === url.id ) {
            song.url = url.url
          }
          return url
        } )
        return song
      } )
      setTopSongs( songsArr )
      setTotalResults( songsArr.length )
      setLoading( false )
    }
    artistDetails( id )
  }, [id] )

  // Artist's all songs 
  useEffect( () => {
    // eslint-disable-next-line
    const getAllSongs = async () => {
      try {
        const res = await getAllSongsByArtist( id )
        // setTotalResults( res.total )
        console.log( res )
        return res
      } catch ( error ) {
        console.log( error )
      }
    }
    getAllSongs( id )
  }, [id] )

  useEffect( () => {
    const getAllAlbums = async () => {
      setLoading( true )
      const artistAlbums = await getAlbumsByArtistId( id, PAGE_SIZE )
      console.log( artistAlbums?.artist?.name, "artist 2nd render" )
      setTopAlbums( artistAlbums.hotAlbums )
      setLoading( false )
    }
    getAllAlbums( id, PAGE_SIZE )
  }, [id] )

  // Get artist's all albums
  const moreAlbums = async ( key, id, page ) => {
    // await new Promise( r => setTimeout( r, 500 ) )
    const res = await fetch( `http://localhost:4000/artist/album?id=${id}&offset=0&limit=${PAGE_SIZE * page}`, { withCredentials: true } )
    const result = await res.json()
    return result
  }
  const { resolvedData, latestData, status } = usePaginatedQuery( ['hotAlbums', id, page], moreAlbums )
  const pageCount = Math.ceil( artist?.artist?.albumSize / PAGE_SIZE )
  const nextAlbumsArr = ( pageNum ) => setCurrentAlbums( pageNum )
  const cache = useQueryCache()

  useEffect( () => {
    const timer = setTimeout( () => {
      if ( latestData?.more ) {
        setShowMore( true )
        setLoading( true )
        cache.prefetchQuery( ['hotAlbums', id, page], moreAlbums, {
          staleTime: 5 * 60 * 1000,
          // canFetchMore: latestData?.more
        } )
        // console.log( page, "page insideTimeout" )
      }
      setLoading( false )
    }, 1000 )
    return () => {
      clearTimeout( timer )
      // console.log( "render on unmount", timer )
    }
  }, [id, page] )

  const playCurrent = ( index ) => {
    let current = topSongs[index]
    tracksArr = [...state.tracks, current]
    let deduped = [...new Set( tracksArr )]
    state.tracks = deduped
    let newIndex = deduped.indexOf( current )
    playTrack( newIndex )
    setState( state => ( { ...state } ) )
  }

  // Current songs paginated
  const indexOfLastSong = currentPage * resultsPerPage
  const indexOfFirstSong = indexOfLastSong - resultsPerPage
  const currentSongs = topSongs.slice( indexOfFirstSong, indexOfLastSong )
  const nextPage = ( pageNumber ) => setCurrentPage( pageNumber )

  const Artist = artist?.artist // variousArtistId = 104700

  return (
    <Fragment>
      {loading
        ? <Loading />
        : Artist || artist
          ? <div className="banner__main">
            <BackgroundBanner {...artist} />
            {/* Artist Details */}
            <Box
              px={[0, 0, 1, 2]}
              pt={2}
              bg={"brand.svtPlayBlack"}
              color="white"
            >
              <p>
                Popular Records: {" "}
                {Artist?.albumSize > PAGE_SIZE ? topAlbums?.length : topAlbums?.length}
              </p>
              <p>Full Discography:  {" "}
                {Artist?.albumSize}
              </p>

              <div className="playlists__inner details">
                {latestData?.artist?.albumSize > topAlbums?.length
                  ? <Box>
                    <button onClick={() => setPage( old => Math.max( old - 1, 1 ) )} disabled={page <= 1}>
                      Prev Page
                    </button>
                    {" " + page + " "}
                    <button onClick={() => setPage( old => ( !latestData || !latestData?.more ? old : old + 1 ) )} disabled={latestData?.more === false}>
                      Next Page
                    </button>
                  </Box>
                  : null}
                <ButtonIcons />
              </div>

              <SimilarArtists similarArtists={simiArtists?.similarArtists} />

              {/**Artist--TOP50 songslist*/}
              <article className="queue__wrapper">
                <AccordianComp
                  header={`${Artist?.name.toUpperCase()} TOP TRACKS`}
                  onToggle={onToggle}
                />
                <table id="global__list">
                  {toggle ? currentSongs && currentSongs.map( track => {
                    let index = topSongs.indexOf( track )
                    return (
                      <tbody key={track.id} id="global__listBody">
                        <tr className="queue__item">
                          <td>{index + 1}</td>
                          <td className="queue__item title">
                            <Link to={`/song/${track.id}`}>
                              <p>{track.name}</p>
                              <span>
                                {track.al.name}
                              </span>
                            </Link>
                          </td>
                          <td className="queue__item length">
                            {getTime( track.dt )}
                          </td>
                          <td className="queue__item play">
                            <button
                              type="button"
                              className="queue__item btn"
                              onClick={() => playCurrent( index )}>
                              {currentTrackName === track.name && isPlaying
                                ? <RiPauseLine className="paus__btn"
                                />
                                : <RiPlayLine className="play__btn"
                                />
                              }
                            </button>
                          </td>
                          <td className="queue__item svg">
                            <RiHeartLine style={{
                              width: "0.7em",
                              height: "0.7em"
                            }}
                            />
                          </td>
                        </tr>
                      </tbody>
                    )
                  } ) : null
                  }
                </table>
              </article>
              {topSongs.length > resultsPerPage
                ? <Pagination
                  resultsPerPage={resultsPerPage}
                  totalResults={totalResults}
                  nextPage={nextPage}
                />
                : null
              }

              {/** Artist's Top Albums */}
              <article>
                <div className="playlists__wrapper">
                  <SectionHeader
                    title="TOP RECORDS"
                  // iconType="iconBtn"
                  // iconOne={<ChevronDownIcon />} iconTwo={null}
                  // setShowMore={setShowMore}
                  />
                  <div className="playlists__inner">
                    {topAlbums?.slice( 0, 10 )?.map( ( al, i ) => {
                      let albumType = "Studio Edition/Record"
                      if ( al.type === "专辑" || al.type === "未知" ) {
                        al.type = albumType
                      }
                      if ( al.company === "环球唱片" || al.company === "索尼音乐" || al.company === "华纳音乐" || al.company === "独立发行" ) {
                        let record = i18n?.options?.resources?.album['en-US'][i]?.recordLabel
                        al.company = record
                      }
                      return (
                        <Link
                          to={`/album/${al.id}`}
                          key={al.id}
                          className="playlists__body">
                          <img src={httpToHttps( al.picUrl + "?param=300y300" )}
                            alt={al.name}
                            loading="lazy"
                          />
                          <p>{al.name}</p>
                          <span>
                            {" ["}{formatDate( al?.publishTime ).slice( 0, 4 )}{"] "}
                          </span>
                          <span>{al.size} </span>
                          <span>{al.type} </span>
                        </Link>
                      )
                    } )
                    }
                  </div>
                </div>
              </article>
            </Box>
            {showMore
              ? <AllAlbums
                {...resolvedData}
                nextAlbumsArr={nextAlbumsArr}
                totalResults={resolvedData?.artist?.albumSize}
                resultsPerPage={PAGE_SIZE}
                pageCount={pageCount}
                status={status}
              />
              : null}
          </div>
          : null
      }
    </Fragment>
  )
}